// import {useEffect, useState} from 'react'
// import client from './sanityClient'
// import {pageQuery, siteConfigQuery} from './sanityQueries'

// type PdfResource = {
//   title: string
//   description?: string
//   buttonText?: string
//   openInNewTab?: boolean
//   file?: {
//     asset?: {
//       url?: string
//     }
//   }
// }

// type CtaCard = {
//   title: string
//   subtitle?: string
//   description?: string
//   linkText?: string
//   linkUrl?: string
//   openInNewTab?: boolean
//   image?: { asset?: { url?: string } }
// }

// type PageSection = {
//   sectionType?: string
//   heading?: string
//   body?: string
//   body2?: string
//   content?: Array<any>
//   image?: { asset?: { url?: string } }
//   images?: Array<{ asset?: { url?: string } }>
//   pdfs?: PdfResource[]
//   cards?: CtaCard[]
// }

// type HeroSection = {
//   eyebrow?: string
//   headline?: string
//   subheadline?: string
//   backgroundImage?: { asset?: { url?: string } }
//   buttons?: CtaCard[]
// }

// type PageContent = {
//   title?: string
//   pageType?: string
//   seoTitle?: string
//   seoDescription?: string
//   hero?: HeroSection
//   sections?: PageSection[]
//   pdfs?: PdfResource[]
// }

// type SiteConfig = {
//   title?: string
//   description?: string
//   url?: string
//   phone?: string
//   email?: string
//   address?: string
//   logo?: { asset?: { url?: string } }
//   navigation?: { label?: string; href?: string }[]
//   brochures?: PdfResource[]
//   hero?: HeroSection
// }

// export default function useSanityPage(pageSlug: string, siteId: string) {
//   const [page, setPage] = useState<PageContent | null>(null)
//   const [siteConfig, setSiteConfig] = useState<SiteConfig | null>(null)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState<string | null>(null)

//   useEffect(() => {
//     let active = true
//     setLoading(true)
//     setError(null)

//     Promise.all([
//       client.fetch(pageQuery, {slug: pageSlug}),
//       client.fetch(siteConfigQuery, {siteId}),
//     ])
//       .then(([pageData, siteData]) => {
//         if (!active) return
//         setPage(pageData)
//         setSiteConfig(siteData)
//       })
//       .catch((err) => {
//         if (!active) return
//         setError(err?.message || String(err))
//       })
//       .finally(() => {
//         if (!active) return
//         setLoading(false)
//       })

//     return () => {
//       active = false
//     }
//   }, [pageSlug, siteId])

//   return {page, siteConfig, loading, error}
// }

import {useEffect, useState} from 'react'
import client from './sanityClient'
import {pageQuery, siteConfigQuery} from './sanityQueries'

type PdfResource = {
  title: string
  description?: string
  buttonText?: string
  openInNewTab?: boolean
  file?: {
    asset?: {
      url?: string
    }
  }
}

type CtaCard = {
  title: string
  subtitle?: string
  description?: string
  linkText?: string
  linkUrl?: string
  openInNewTab?: boolean
  image?: {asset?: {url?: string}}
}

type PageSection = {
  sectionType?: string
  heading?: string
  body?: string
  body2?: string
  content?: Array<any>
  image?: {asset?: {url?: string}}
  images?: Array<{asset?: {url?: string}}>
  pdfs?: PdfResource[]
  cards?: CtaCard[]
}

type HeroSection = {
  eyebrow?: string
  headline?: string
  subheadline?: string
  backgroundImage?: {asset?: {url?: string}}
  buttons?: CtaCard[]
}

type PageContent = {
  title?: string
  pageType?: string
  seoTitle?: string
  seoDescription?: string
  hero?: HeroSection
  sections?: PageSection[]
  pdfs?: PdfResource[]
}

type SiteConfig = {
  title?: string
  description?: string
  url?: string
  phone?: string
  email?: string
  address?: string
  logo?: {asset?: {url?: string}}
  navigation?: {label?: string; href?: string}[]
  brochures?: PdfResource[]
  hero?: HeroSection
}

export default function useSanityPage(pageSlug: string, siteId: string) {
  const [page, setPage] = useState<PageContent | null>(null)
  const [siteConfig, setSiteConfig] = useState<SiteConfig | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let active = true
    setLoading(true)
    setError(null)

    Promise.all([
      client.fetch<any>(pageQuery, {slug: pageSlug}),
      client.fetch<any>(siteConfigQuery, {siteId}),
    ])
      .then(([pageData, siteData]) => {
        if (!active) return
        setPage(pageData)
        setSiteConfig(siteData)
      })
      .catch((err) => {
        if (!active) return
        setError(err?.message || String(err))
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [pageSlug, siteId])

  return {page, siteConfig, loading, error}
}
